































































































































































































































































































































































































































































































































































































































































































































































































































































import DialogoDeEdicaoDeFornecedor from '@/components/fornecedor/DialogoDeEdicaoDeFornecedor.vue'
import BuscaDeProdutoDropdown from '@/components/produto/BuscaDeProdutoDropdown.vue'
import { ImportacaoDeNota, ProdutoDaImportacao } from '@/models/ImportacaoDeNota'
import { fixarCasasDecimais, formatarCnpjOuCpf } from '@/shareds/formatadores'
import { obrigatorio } from '@/shareds/regras-de-form'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { FinalizarImportacaoDeNotaDoFornecedorUseCase, FindAtributoUseCase, FindGradeDeProdutosUseCase, FindImportacaoUseCase, ImportarNotaDoFornecedorUseCase, FindProdutoUseCase } from '@/usecases'
import { Vue, Component, Ref, Watch } from 'vue-property-decorator'
import ProdutoDaImportacaoDeNota from "./ProdutoDaImportacaoDeNota.vue"
import SeletorDeMarca from '@/components/produto/SeletorDeMarca.vue'
import { AtributoDoProduto, Marca, Produto, Variacao, Variante } from '@/models'
import SeletorDeTag from '@/components/produto/SeletorDeTag.vue'
import SeletorDeCategoria from '../produtos/EdicaoDeProduto/SeletorDeCategoria.vue'
import SeletorDeEstacao from '@/components/produto/SeletorDeEstacao.vue'
import SeletorDeGenero from '@/components/produto/SeletorDeGenero.vue'
import { round } from '@/shareds/number-utils'
import CampoDePercentual from '@/components/ui/CampoDePercentual.vue'
import { uploadFilesToS3 } from '@/shareds/s3/files'
import Confirmacao from '@/components/ui/Confirmacao.vue'
import CampoDecimal from '@/components/ui/CampoDecimal.vue'
import DialogoDeSelecaoDeGradeDeProdutos from '@/components/produto/DialogoDeSelecaoDeGradeDeProdutos.vue'
import cartesianProduct from 'cartesian-product'
import SeletorDeNcm from '@/components/ui/SeletorDeNcm.vue'
import SeletorDeUnidadeDeMedida from '@/components/produto/SeletorDeUnidadeDeMedida.vue'
import DialogoDeAdicionarCor from '@/components/produto/DialogoDeAdicionarCor.vue'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import AppStore from '@/store/vuex/aplicacao/AppStore'
const IMPORTACAO_DE_NOTA = 'IMPORTACAO_DE_NOTA'

@Component({
	components: {
		BuscaDeProdutoDropdown,
		DialogoDeSelecaoDeGradeDeProdutos,
		DialogoDeEdicaoDeFornecedor,
		ProdutoDaImportacaoDeNota,
		SeletorDeMarca,
		SeletorDeTag,
		SeletorDeCategoria,
		SeletorDeEstacao,
		SeletorDeGenero,
		CampoDePercentual,
		Confirmacao,
		SeletorDeNcm,
		SeletorDeUnidadeDeMedida,
		DialogoDeAdicionarCor,
	},
})
export default class TelaDeImportacaoDeNotaAntiga extends Vue {
	@Ref() form!: HTMLFormElement
	@Ref() dialogoDeFornecedor!: DialogoDeEdicaoDeFornecedor
	@Ref() dialogoDeSelecaoDeGradeDeProdutos!: DialogoDeSelecaoDeGradeDeProdutos
	@Ref() dialogoDeAdicionarCor!: DialogoDeAdicionarCor
	@Ref() confirmarAlteracaoDaMargemDeLucro!: Confirmacao
	@Ref() confirmarAlteracaoDasMarcas!: Confirmacao
	@Ref() campoDeMargemDeLucro!: CampoDecimal

	AlertModule = AlertModule

	importarNotaDoFornecedorUseCase = new ImportarNotaDoFornecedorUseCase()
	finalizarImportacaoDeNotaDoFornecedorUseCase = new FinalizarImportacaoDeNotaDoFornecedorUseCase()
	findGradeDeProdutosUseCase = new FindGradeDeProdutosUseCase()
	findAtributosUseCase = new FindAtributoUseCase()
	findImportacaoUseCase = new FindImportacaoUseCase()
	findSkusUseCase = new FindProdutoUseCase()

	formatarCnpjOuCpf = formatarCnpjOuCpf
	obrigatorio = obrigatorio
	fixarCasasDecimais = fixarCasasDecimais
	file: File | null = null
	carregando = false
	criandoFornecedor = false
	enviando = false
	salvandoEdicaoDeProduto = false
	margemArredondamentoAcima = 0.99
	margemArredondamentoAbaixo = 0.00
	importacaoDeNota: ImportacaoDeNota | null = localStorage[IMPORTACAO_DE_NOTA]
		? JSON.parse(localStorage[IMPORTACAO_DE_NOTA])
		: null
	mostrarDialogoDeEdicaoDeProduto = false
	produtoEmEdicao: Produto = {} as Produto
	indiceEmEdicao = 0
	margemDeLucroGeral = 0
	naoDeveMovimentarEstoque = false
	naoDeveAtualizarTabelaDePreco = false
	naoUtilizarArredondamentoDecimal = false
	gerandoVariantes = false
	podeFinalizar = false
	carregandoInicioDoProcessoDeImportacao: string | null = null

	arquivosEmProcessamento: ImportacaoDeNota[] = []
	carregandoStatusProcessamento = false
	intervaloDeBusca: number | null = null
	dialogoErro = false
	arquivoComErro: any

	snackbar = false;
	snackbarText = '';
	snackbarColor = 'success';

	headersProcessamento = [
		{ text: 'Numero da Nota', value: 'numeroNota', sortable: true },
		{ text: 'Status', value: 'status', sortable: true, align: 'center' },
		{ text: 'Data/Hora', value: 'dataHora', sortable: true },
		{ text: 'Progresso', value: 'progresso', sortable: false, align: 'center' },
		{ text: 'Ações', value: 'acoes', sortable: false, align: 'end' },
	]

	headersComCriacaoDeProduto = [
		{ text: 'Nome', value: 'nota.xProd' },
		{ text: 'Marca', value: 'encontrado.marca.nome' },
		{ text: 'Cod. do fornecedor', value: 'nota.cProd'},
		{ text: 'Quantidade', value: 'nota.qCom'},
		{ text: 'Valor un.', value: 'nota.vUnCom'},
		{ text: 'Valor total', value: 'nota.vProd'},
		{ text: 'Preço de venda varejo', value: 'precoFinalVarejo'},
		{ text: 'Margem de lucro', value: 'margemDeLucro' },
		{ text: 'Produto associado', value: 'encontrado' },
	]

	headersSemCriacaoDeProduto = [
		{ text: 'Nome', value: 'nota.xProd' },
		{ text: 'Cod. do fornecedor', value: 'nota.cProd'},
		{ text: 'Quantidade', value: 'nota.qCom'},
		{ text: 'Valor un.', value: 'nota.vUnCom'},
		{ text: 'Valor total', value: 'nota.vProd'},
		{ text: 'Produto associado', value: 'encontrado' },
	]

	get podeCriarProduto() {
		return (this.importacaoDeNota && this.importacaoDeNota.lojaDestinoDaImportacao.configuracaoDaLoja &&
											this.importacaoDeNota.lojaDestinoDaImportacao.configuracaoDaLoja.criarProdutoImportacaoEntrada)
	}

	get editandoProdutoJaCadastrado() {
		return this.produtoEmEdicao && !!this.produtoEmEdicao.id
	}

	get contadorProcessando() {
		return this.arquivosEmProcessamento.filter(f => f.status === 'Em Andamento').length
	}

	get contadorConcluidos() {
		return this.arquivosEmProcessamento.filter(f => f.status === 'Concluído').length
	}

	get contadorErros() {
		return this.arquivosEmProcessamento.filter(f => f.status === 'Incompleto').length
	}

	get contadorPendente() {
		return this.arquivosEmProcessamento.filter(f => f.status === 'Pendente').length
	}

	verificaSeCriaProduto(item: ProdutoDaImportacao, importacaoDeNota) {
		return (
			(item.encontrado && item.encontrado.id) 
			|| importacaoDeNota 
			&& (importacaoDeNota.lojaDestinoDaImportacao.configuracaoDaLoja && !importacaoDeNota.lojaDestinoDaImportacao.configuracaoDaLoja.criarProdutoImportacaoEntrada)
		) && item.encontrado && item.encontrado.tipo !== 'Com Variantes'
	}

	quantidadesInformadasValidas() {
		if (!this.importacaoDeNota) return true
		if (this.importacaoDeNota.produtos.filter(produto => produto.encontrado && produto.encontrado.tipo === 'Com Variantes').length === 0) return true

		const quantidadeInformadaTotal = this.importacaoDeNota.produtos.filter(produto => produto.encontrado && produto.encontrado.tipo === 'Com Variantes').map(produto => produto.quantidadeInformada||0).reduce((total, valor) => total + valor)
		const quantidadeEsperadaTotal = this.importacaoDeNota.produtos.filter(produto => produto.encontrado && produto.encontrado.tipo === 'Com Variantes').map(produto => parseInt(produto.nota.qCom)||0).reduce((total, valor) => total + valor)
		return quantidadeInformadaTotal === quantidadeEsperadaTotal
	}
	
	get usuario() {
		return UserLoginStore.usuario?.id
	}

	get permiteAbrirDiversosProcessosDeImportacao(){
		if(!UserLoginStore.perfil) return false
		return UserLoginStore.perfil.permissoes.includes('permite-abrir-diversos-processos')
	}

	async importarNota() {
		try {
			this.carregando = true

			
			if(!this.usuario) return

			if(!this.permiteAbrirDiversosProcessosDeImportacao){
				const possuiProcessoEmAberto = await this.findImportacaoUseCase.possuiImportacoesEmAbertoNoUsuarioLogado(this.usuario);

				if(!possuiProcessoEmAberto){
					AlertModule.setError('Já existe um processo em aberto para o usuario, aguarde finalizar para prosseguir!');
					this.carregando = false;
					return
				}
			}

			await this.importarNotaDoFornecedorUseCase.execute(
				this.file,
				(fornecedor) => this.dialogoDeFornecedor.mostrar(fornecedor, true),
			);
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.carregando = false
			this.buscarItensDeImportacao()
			AlertModule.setSuccess('Importação concluída. Verifique os produtos importados.')
			this.file = null
		}
	}

	created() {
		if (this.importacaoDeNota) {
			for (let i = 0;i < this.importacaoDeNota.produtos.length; i++) {
				this.importacaoDeNota.produtos[i].indice = i
			}
		}

		this.buscarItensDeImportacao();
	}

	getStatusColor(status: string): string {
		const colors = {
			Pendente: 'orange darken-2',
			'Em Andamento': 'blue',
			Concluído: 'success',
			Incompleto: 'error',
		}
		return colors[status] || 'grey'
	}

	getStatusIcon(status: string): string {
		const icons = {
			Pendente: 'mdi-clock-outline',
			'Em Andamento': 'mdi-loading mdi-spin',
			Concluído: 'mdi-check-circle',
			Incompleto: 'mdi-alert-circle',
		}
		return icons[status] || 'mdi-help-circle'
	}

	getStatusText(status: string): string {
		const texts = {
			Pendente: 'Pendente',
			'Em Andamento': 'Em Andamento',
			Concluído: 'Concluído',
			Incompleto: 'Incompleto',
		}
		return texts[status] || status
	}

	formatarData(data: string | Date): string {
		if (!data) return '-'
		const d = new Date(data)
		return isNaN(d.getTime()) ? '-' : d.toLocaleDateString('pt-BR')
	}

	formatarHora(data: string | Date): string {
		if (!data) return '-'
		const d = new Date(data)
		return isNaN(d.getTime())
			? '-'
			: d.toLocaleTimeString('pt-BR', {
				hour: '2-digit',
				minute: '2-digit',
			})
	}

	async visualizarProcessamento(arquivo) {

		try {
			
			const chaveAcesso = this.obterChaveNota(arquivo.itens[0].item);
			this.carregandoInicioDoProcessoDeImportacao = chaveAcesso

			if(!chaveAcesso){
				return AlertModule.setError('Chave de acesso da nota não encontrada. Acione o suporte!.')
			}

			this.importacaoDeNota = await this.importarNotaDoFornecedorUseCase.buscarImportacaoDeNota(chaveAcesso);

			if(this.importacaoDeNota){
				if(this.importacaoDeNota.fornecedor.encontrado && this.importacaoDeNota.fornecedor.encontrado.markup > 0){
					this.margemDeLucroGeral = this.importacaoDeNota.fornecedor.encontrado.markup
					this.mostrarConfimacao()
				}

				this.importacaoDeNota.produtos.forEach(produto => {
					if (produto.encontrado && !produto.encontrado.id && this.importacaoDeNota) {
						produto.encontrado.marca = this.importacaoDeNota.fornecedor.encontrado?.marca || null
					}
				})

				this.importacaoDeNota.produtos.forEach(produto => {
					if (produto.encontrado && produto.encontrado.tipo === 'Com Variantes') {
						produto.encontrado.variantes.sort((varianteA, varianteB) =>
							this.obterValorDoAtributo(varianteA, 'Tamanho').localeCompare(this.obterValorDoAtributo(varianteB, 'Tamanho')),
						)

						produto.encontrado.variantes.sort((varianteA, varianteB) =>
							this.obterValorDoAtributo(varianteA, 'Cor').localeCompare(this.obterValorDoAtributo(varianteB, 'Cor')),
						)
					}
				})

				for (let i = 0;i < this.importacaoDeNota.produtos.length; i++) {
					this.importacaoDeNota.produtos[i].indice = i
				}

				this.importacaoDeNota.produtos.sort((produtoA, produtoB) => produtoA.nota.nItem - produtoB.nota.nItem)
			} else {
				AlertModule.setError('Não foi possível carregar os detalhes do processamento. Tente novamente mais tarde.')
				this.carregandoInicioDoProcessoDeImportacao = null
				return
			}

		} catch (error) {
			AlertModule.setError('Não foi possível iniciar os processos de importação. Tente novamente mais tarde.')
			this.carregandoInicioDoProcessoDeImportacao = null
			return
		} finally {
			this.carregandoStatusProcessamento = false
			this.snackbarText = 'Iniciando Importação da Nota: ' + this.obterNumeroNota(arquivo.itens[0].item);
			this.snackbarColor = 'success';
			this.snackbar = true;
			this.carregandoInicioDoProcessoDeImportacao = null
			this.buscarItensDeImportacao();
		}
	}

	async reprocessarArquivo(arquivo) {
		//TODO: Caso futuramente haja necessidade de reprocessar um arquivo com erro,
		//implementar a chamada para o backend aqui
		try {
			AlertModule.setInfo(`Reprocessando arquivo: ${this.obterNumeroNota(arquivo.itens[0].item)}`)
			arquivo.progresso = 0
			
		} catch (error) {
			AlertModule.setError(error)
		}
	}

	mostrarErro(arquivo) {
		this.arquivoComErro = {
			chNfe: this.obterNumeroNota(arquivo.itens[0].item),
			mensagemDeErro: arquivo.itens[0].mensagemDeErro,
		}

		this.dialogoErro = true
	}

	async removerArquivo(arquivo) {
		try{
			await this.importarNotaDoFornecedorUseCase.delete(this.obterChaveNota(arquivo.itens[0].item))
			this.buscarItensDeImportacao()
		} catch(e) {
			AlertModule.setError(e)
		} finally {
			this.snackbarText = 'Registro removido com sucesso!';
			this.snackbarColor = 'success';
			this.snackbar = true;
		}
	}

	get tiposDeProdutos(): BuscaDeProdutoDropdown['filtros'] {
		return { tipos: ['Padrão', 'Variante', 'Composto'] }
	}

	async salvarMapeamentoDeNotas() {
		if (!this.importacaoDeNota) return;
		if (this.importacaoDeNota.produtos.some(({ encontrado }) => !encontrado)) {
			AlertModule.setError('Existem produtos não associados');
			return;
		}
		if (!this.form.validate()) return;

		try {
			this.enviando = true;

			this.importacaoDeNota.naoDeveAtualizarTabelaDePreco = this.naoDeveAtualizarTabelaDePreco
			this.importacaoDeNota.naoDeveMovimentarEstoque = this.naoDeveMovimentarEstoque

			const importacaoDeNotaBlob = new Blob([JSON.stringify(this.importacaoDeNota)], { type: 'application/json' });
			const importacaoDeNotaFile = new File([importacaoDeNotaBlob], 'importacaoDeNota.json', { type: 'application/json' });

			const informacoesDosArquivos = await uploadFilesToS3([importacaoDeNotaFile], 'importacao-de-notas');
			const urlDoArquivoJson = informacoesDosArquivos.map(({ config }) => config.url)[0];

			if (!urlDoArquivoJson) {
				return AlertModule.setError("Ocorreu um erro interno, contate o suporte");
			}

			const importacaoDeNotaFinalizada = await this.finalizarImportacaoDeNotaDoFornecedorUseCase.execute(urlDoArquivoJson, this.naoDeveMovimentarEstoque, this.naoDeveAtualizarTabelaDePreco);

			if (!importacaoDeNotaFinalizada.feedbackDosTitulos) {
				AlertModule.setSuccess('Processo de nota iniciado com sucesso!');
			} else {
				AlertModule.setInfo(`Processo de nota iniciado com sucesso, porém ${importacaoDeNotaFinalizada.feedbackDosTitulos}`);
			}

		} catch (error: any) {
			AlertModule.setError(error);
			return;
		} finally {
			this.enviando = false;
			this.limparIntegracaoDeNota()
		}
	}

	limparIntegracaoDeNota() {
		localStorage.removeItem(IMPORTACAO_DE_NOTA)
		this.importacaoDeNota = null
	}

	async editarFornecedor() {
		if (!this.importacaoDeNota || !this.importacaoDeNota.fornecedor.encontrado) return
		const fornecedor = await this.dialogoDeFornecedor.mostrar(this.importacaoDeNota.fornecedor.encontrado, false)
		if (!fornecedor) return
		this.importacaoDeNota = {
			...this.importacaoDeNota,
			fornecedor: {
				...this.importacaoDeNota.fornecedor,
				encontrado: fornecedor,
			},
		}
	}

	@Watch('importacaoDeNota', { deep: true, immediate: true })
	onChangeIntegracaoDeNota() {
		if (this.importacaoDeNota) {
			this.importacaoDeNota.produtos.forEach(produto => {
				if (produto.encontrado && produto.encontrado.tipo === 'Com Variantes') {
					produto.quantidadeInformada = produto.encontrado.variantes ? produto.encontrado.variantes.map(variante => variante.quantidadeImportacao||0).reduce((total, valor) => total + valor) : 0
				} else {
					produto.quantidadeInformada = 0
				}
			})

			this.importacaoDeNota.quantidadesPreenchidasCorretamente = this.quantidadesInformadasValidas()
			this.onReloadFinalizar()
		}

		this.file = null
		localStorage.setItem(IMPORTACAO_DE_NOTA, JSON.stringify(this.importacaoDeNota))
	}

	async abrirDialogoDeEditarProduto(produto: ProdutoDaImportacao, indiceEmEdicao: number) {
		if (!produto.encontrado) return

		this.indiceEmEdicao = indiceEmEdicao

		this.produtoEmEdicao = JSON.parse(JSON.stringify(produto.encontrado))

		if (!produto.encontrado.precoCompra) {
			produto.encontrado.precoCompra = produto.encontrado.preco
			produto.encontrado.margemLucro = 0
		}

		this.produtoEmEdicao.margemLucro = produto.margemDeLucro
		this.produtoEmEdicao.precoCompra = produto.encontrado.precoCompra
		this.produtoEmEdicao.preco = produto.precoFinalVarejo
		this.produtoEmEdicao.ncm = {
			id: '',
			descricao: '',
			codigo: produto.nota.NCM,
		}

		this.mostrarDialogoDeEdicaoDeProduto = true
	}

	async salvarProduto() {
		this.salvandoEdicaoDeProduto = true
		if (!this.importacaoDeNota) {
			this.salvandoEdicaoDeProduto = false
			return
		}

		if (!this.produtoEmEdicao.unidadeDeMedida || this.produtoEmEdicao.unidadeDeMedida === ''){
			this.salvandoEdicaoDeProduto = false
			return AlertModule.setError("Obrigatório informar unidade de medida")
		}

		const skusParaValidar: string[] = []
		if (this.produtoEmEdicao.tipo === 'Com Variantes') {
			this.produtoEmEdicao.variantes.forEach(variante => {
				if (!variante.id) skusParaValidar.push(variante.sku)
			})

			if (!this.produtoEmEdicao.id && this.produtoEmEdicao.sku) skusParaValidar.push(this.produtoEmEdicao.sku)
		}

		try {
			if (skusParaValidar.length > 0) {
				const skusJaExistentes = await this.findSkusUseCase.validarSkusJaExistentes({ skus: skusParaValidar })

				if (skusJaExistentes.length > 0) {
					AlertModule.setError(`Os SKUs ${skusJaExistentes.join(', ')} já existem`)
					this.salvandoEdicaoDeProduto = false
					return
				}
			}

			this.importacaoDeNota.produtos[this.indiceEmEdicao].encontrado = JSON.parse(JSON.stringify(this.produtoEmEdicao))
			this.importacaoDeNota.produtos[this.indiceEmEdicao].margemDeLucro = this.produtoEmEdicao.margemLucro || 0
			this.importacaoDeNota.produtos[this.indiceEmEdicao].precoFinalVarejo = this.arredondarPreco(this.produtoEmEdicao.preco || 0)
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.salvandoEdicaoDeProduto = false
		}

		this.fecharDialogoDeEdicaoDeProduto()
	}

	fecharDialogoDeEdicaoDeProduto() {
		this.produtoEmEdicao = {} as Produto
		this.indiceEmEdicao = 0
		this.mostrarDialogoDeEdicaoDeProduto = false
	}

	calculaPrecoVarejo() {
		if (!this.produtoEmEdicao) return
		
		const precoCompra = this.produtoEmEdicao.precoCompra || 0
		const margemDeLucro = 1 + (this.produtoEmEdicao.margemLucro || 0) / 100
		
		this.produtoEmEdicao.preco = this.arredondarPreco(round(
			(precoCompra * margemDeLucro ).toString(),
			2,
		))
	}

	formatarMenssagem() {
		return `
				<div><h2 class="formatarAviso">Aviso!</h2></div>
				<div class="mt-4">
					Você deseja continuar? 
					Se confirmar, todas as margens de lucro serão atualizadas
				</div>
			`
	}

	formatarMenssagemDasMarcas() {
		return `
				<div><h2 class="formatarAviso">Aviso!</h2></div>
				<div class="mt-4">
					Se confirmar, todos os produtos desta nota serão associados a esta marca
				</div>
			`
	}

	async mostrarConfimacao() {
		if(!this.importacaoDeNota) return
		if(!await this.confirmarAlteracaoDaMargemDeLucro.mostrar()) return
		
		this.inserirMargemDeLucroNosItens()
	}

	inserirMargemDeLucroNosItens() {
		if(!this.importacaoDeNota) return
		
		this.importacaoDeNota.produtos.forEach(produto => {
			produto.margemDeLucro = this.margemDeLucroGeral

			this.modificarMargemDeLucro(produto)
		})
	}

	formatarNumero(numero) {
		if(numero == null || numero == undefined) {
			return ''
		}
		return this.fixarCasasDecimais(parseFloat(numero), 2)
	}

	modificarMargemDeLucro(produto: ProdutoDaImportacao) {
		if (!produto) return

		if (produto.margemDeLucro === 0) {			
			produto.precoFinalVarejo = this.arredondarPreco(Number(produto.nota.vUnCom))
			return
		}

		const precoCompra = Number(produto.nota.vUnCom) || 0
		const margemDeLucro = 1 + (produto.margemDeLucro || 0) / 100

		const precoCalculado = round(
			(precoCompra * margemDeLucro).toString(),
			2,
		)

		const precoArredondado = this.arredondarPreco(precoCalculado)

		produto.precoFinalVarejo = round(precoArredondado.toString(), 2)
	}

	arredondarPreco(preco: number) {
		if (this.naoUtilizarArredondamentoDecimal) return preco

		const casasDecimais = preco - Math.floor(preco)
		
		let precoArredondado = Math.floor(preco)
		
		if (casasDecimais >= 0.50) {
			precoArredondado += this.margemArredondamentoAcima
		} else {
			precoArredondado += this.margemArredondamentoAbaixo
		}

		return precoArredondado
	}

	obterValorDoAtributo(variante, atributoEsperado) {
		const valorFiltrado =  variante.atributosVariante.filter(atributo => atributo.nome.toUpperCase() === atributoEsperado.toUpperCase())

		if (valorFiltrado.length > 0) {
			return valorFiltrado[0].valor
		}
		return 'Sem '+atributoEsperado
	}

	montarGradeDoProduto() {
		this.dialogoDeSelecaoDeGradeDeProdutos.mostrar()
	}

	adicionarCoresAoProduto() {
		this.dialogoDeAdicionarCor.mostrar(this.produtoEmEdicao)
	}

	async criarVariacoesDoProdutoEmEdicao(cores, tamanhos) {
		this.produtoEmEdicao.tipo = 'Com Variantes'

		if (this.produtoEmEdicao.tipo === 'Com Variantes') {
			try {
				this.gerandoVariantes = true
				const atributos = await this.findAtributosUseCase.findAll()
				
				const atributoCor = atributos.filter(atributo => atributo.nome.toUpperCase() === 'COR')[0]
				const atributoTamanho = atributos.filter(atributo => atributo.nome.toUpperCase() === 'TAMANHO')[0]

				this.produtoEmEdicao.atributosProduto = []

				this.produtoEmEdicao.atributosProduto.push({
					id: '',
					atributo: atributoCor,
					valores: cores,
					descontoVarejo: 0,
				} as AtributoDoProduto)

				this.produtoEmEdicao.atributosProduto.push({
					id: '',
					atributo: atributoTamanho,
					valores: tamanhos,
					descontoVarejo: 0,
				} as AtributoDoProduto)

				const variantes = this.criarVariantesDoProduto(Object.create(this.produtoEmEdicao), this.produtoEmEdicao.atributosProduto)

				this.produtoEmEdicao.variantes = variantes
			} catch(error) {
				AlertModule.setError(error)
			} finally {
				this.gerandoVariantes = false
			}
		}
	}

	async criarVariacoesDeCorDoProdutoEmEdicao(cores: string[]) {
		this.produtoEmEdicao.tipo = 'Com Variantes'

		if (this.produtoEmEdicao.tipo === 'Com Variantes') {
			try {
				this.gerandoVariantes = true

				for (const cor of cores) {
					
					this.produtoEmEdicao.atributosProduto.filter(atributo => atributo.atributo.nome.toUpperCase() === 'COR')[0].valores.push(cor)

					const atributosTamanhos = this.produtoEmEdicao.atributosProduto.filter(atributo => atributo.atributo.nome.toUpperCase() === 'TAMANHO')
					let atributosCores = Object.values(this.produtoEmEdicao.atributosProduto.filter(atributo => atributo.atributo.nome.toUpperCase() === 'COR'))
					
					atributosCores = atributosCores.map(atributoCor => {
						atributoCor.valores = atributoCor.valores.filter(valor => cores.includes(valor))
						return atributoCor
					})

					const novasVariantes = this.criarVariantesDoProduto(this.produtoEmEdicao, [...atributosTamanhos, ...atributosCores])

					for (const variante of novasVariantes) {
						this.produtoEmEdicao.variantes.push(variante)	
					}
				}
				
			} catch(error) {
				AlertModule.setError(error)
			} finally {
				this.gerandoVariantes = false
			}
		}
	}

	removerEspacos(str) {
		return str.replace(/\s+/g, "")
	}

	criarVariantesDoProduto(
		produto: Produto,
		atributos: AtributoDoProduto[],
	) {

	
		const atributosDaVariante = atributos
			.filter(({ valores }) => valores.length)
			.map(({ id, atributo, valores }) =>
				valores.map(valor => ({
					id,
					nome: atributo.nome,
					valor,
				})),
			)
		const variacoes: Variacao[] = cartesianProduct(atributosDaVariante)
		const variantes = variacoes.map<Variante>(variacao => ({
			id: '',
			ncm: null,
			cest: null,
			regraFiscal: null,
			idProdutoPai: produto.id,
			tipo: "Variante",
			tags: produto.tags,
			descricao: null,
			categoria: produto.categoria,
			urlImagens: produto.urlImagens,
			sku: produto.sku
				+ this.removerEspacos(variacao.filter(vari => vari.nome.toUpperCase() === 'TAMANHO')[0].valor.toUpperCase())
				+ this.removerEspacos(variacao.filter(vari => vari.nome.toUpperCase() === 'COR')[0].valor.toUpperCase()),
			preco: null,
			pesoLiquido: produto.pesoLiquido,
			pesoBruto: produto.pesoBruto,
			descontoVarejo: null,
			marca: produto.marca,
			nome: produto.nome,
			atributosVariante: variacao,
			temGarantia: produto.temGarantia,
			regrasFiscais: [],
			eans: [],
			unidadeDeMedida: produto.unidadeDeMedida,
			identificadores: [],
			produtoDesativado: produto.produtoDesativado,
			produtoIntegrado: produto.produtoIntegrado,
			genero: produto.genero,
			fatorDeConversao: produto.fatorDeConversao,
			unidadeDeConversao: produto.unidadeDeConversao,
			estacao: produto.estacao,
			isValePresente: false,
			skuPai: produto.skuPai,
			quantidadeImportacao: 0,
			fornecedor: produto.fornecedor,
			precoCompra: null,
			margemLucro: null,
			nomeCompleto: produto.nome + ' ' + variacao.filter(vari => vari.nome.toUpperCase() === 'COR')[0].valor + '/' + variacao.filter(vari => vari.nome.toUpperCase() === 'TAMANHO')[0].valor,
			familiasDoProduto: produto.familiasDoProduto,
			varianteVinculada: null,
			vinculada: false,
			produtoIncompleto: false,
			tipoDaOrigemDoProduto: 'Comprado',
			codigoOrigemDoProduto: 0,
		}))
		return variantes
	}

	async onReloadFinalizar() {
		if (!this.importacaoDeNota) return

		this.podeFinalizar = this.importacaoDeNota.produtos.filter(produto => produto.encontrado && produto.encontrado.tipo && produto.encontrado.tipo === 'Com Variantes').length > 0 
			&& !this.importacaoDeNota.quantidadesPreenchidasCorretamente
	}

	async aplicarMarcaEmTodosProdutos(marcaSelecionada: Marca, produtoDaImportacao: ProdutoDaImportacao) {
		if (!this.importacaoDeNota) return
		if (!marcaSelecionada) return

		const primeiroProdutoSelecionavel = this.importacaoDeNota.produtos.find(produto => 
			produto.encontrado !== null && !(produto.encontrado && produto.encontrado.id),
		)

		if (primeiroProdutoSelecionavel && primeiroProdutoSelecionavel.indice === produtoDaImportacao.indice) {
			if (await this.confirmarAlteracaoDasMarcas.mostrar()) {
				this.importacaoDeNota.produtos.forEach(produto => {
					if ((produto.encontrado !== null && !(produto.encontrado && produto.encontrado.id))) {
						produto.encontrado.marca = marcaSelecionada
					}
				})
			}
		}
	}

	regraMargemArredondamento = (v: number) => {
		if (v === null || v === undefined) return true
		return v >= 0.00 && v <= 0.99 || 'O valor deve estar entre 0.00 e 0.99'
	}

	async buscarItensDeImportacao(){
		if(!this.usuario) return
		this.carregandoStatusProcessamento = true

		try{
			this.arquivosEmProcessamento = await this.importarNotaDoFornecedorUseCase.buscarItensDeImportacao(this.usuario);
		}catch(error){
			AlertModule.setError(error)
		}finally{
			this.carregandoStatusProcessamento = false
		}
	}

	obterNumeroNota(xmlString: string): string | null {
		const match = xmlString.match(/<nNF>(\d+)<\/nNF>/)
		return match ? 'Nº' + match[1] : null
	}

	obterChaveNota(xmlString: string): string {
		const match = xmlString.match(/<chNFe>(\d+)<\/chNFe>/)
		return match ? match[1] : ''
	}

	get modoNoturno() {
		return AppStore.modoNoturno
	}
}

